export const actions = {
    SET_ADDRESS: 'SET_ADDRESS',
    SET_TEMP_ADDRESS: 'SET_TEMP_ADDRESS',
    SET_STORE_DETAILS: 'SET_STORE_DETAILS',
    SET_TEMP_STORE_DETAILS: 'SET_TEMP_STORE_DETAILS',
    TRANSFER_TEMP_TO_SELECTED: 'TRANSFER_TEMP_TO_SELECTED',
    TRANSFER_ALL_TEMP: 'TRANSFER_ALL_TEMP',
    SET_SAVED_ADDRESSES: 'SET_SAVED_ADDRESSES',
    GET_PLACE_SUGGESTIONS: 'GET_PLACE_SUGGESTIONS',
    GET_PLACE_SUGGESTIONS_SUCCESS: 'GET_PLACE_SUGGESTIONS_SUCCESS',
    GET_PLACE_SUGGESTIONS_FAILED: 'GET_PLACE_SUGGESTIONS_FAILED',

    GET_PLACE_DETAILS: 'GET_PLACE_DETAILS',
    GET_PLACE_DETAILS_SUCCESS: 'GET_PLACE_DETAILS_SUCCESS',
    GET_PLACE_DETAILS_FAILED: 'GET_PLACE_DETAILS_FAILED',

    GET_ADDRESS_FROM_COORDINATES: 'GET_ADDRESS_FROM_COORDINATES',
    GET_ADDRESS_FROM_COORDINATES_SUCCESS: 'GET_ADDRESS_FROM_COORDINATES_SUCCESS',
    GET_ADDRESS_FROM_COORDINATES_FAILED: 'GET_ADDRESS_FROM_COORDINATES_FAILED',

    SET_GEOCODE: 'SET_GEOCODE',
    GET_GEOCODE: 'GET_GEOCODE',
    GET_GEOCODE_SUCCESS: 'GET_GEOCODE_SUCCESS',
    GET_GEOCODE_FAILED: 'GET_GEOCODE_FAILED',

    GET_STORES_BY_LOCATION: 'GET_STORES_BY_LOCATION',
    GET_STORES_BY_LOCATION_SUCCESS: 'GET_STORES_BY_LOCATION_SUCCESS',
    GET_STORES_BY_LOCATION_FAILED: 'GET_STORES_BY_LOCATION_FAILED',

    GET_PICKUP_STORES: 'GET_PICKUP_STORES',
    PICKUP_STORES_SUCCESS: 'PICKUP_STORES_SUCCESS',
    PICKUP_STORES_FAILED: 'PICKUP_STORES_FAILED',

    GET_STORE_DETAILS: 'GET_STORE_DETAILS',
    GET_STORE_DETAILS_SUCCESS: 'GET_STORE_DETAILS_SUCCESS',
    GET_STORE_DETAILS_FAILED: 'GET_STORE_DETAILS_FAILED',
    RESET_STORE_DETAILS: 'RESET_STORE_DETAILS',

    FILTER_STORES_BY_STATE: 'FILTER_STORES_BY_STATE',
    FILTER_STORES_COMPLETE: 'FILTER_STORES_COMPLETE',

    SET_ALCOHOL_RESTRICTIONS: 'SET_ALCOHOL_RESTRICTIONS',
    GET_ALCOHOL_RESTRICTIONS: 'GET_ALCOHOL_RESTRICTIONS',
    DISPLAY_ALCOHOL_RESTRICTION_MODAL: 'DISPLAY_ALCOHOL_RESTRICTION_MODAL',

    VALIDATE_USPS: 'VALIDATE_USPS',
    VALIDATE_USPS_SUCCESS: 'VALIDATE_USPS_SUCCESS',
    VALIDATE_USPS_FAILED: 'VALIDATE_USPS_FAILED',

    UPDATE_ADDRESS: 'UPDATE_ADDRESS',
    UPDATE_ADDRESS_FOR_PICKUP: 'UPDATE_ADDRESS_FOR_PICKUP',
    UPDATE_ADDRESS_FROM_RECENT: 'UPDATE_ADDRESS_FROM_RECENT',

    ADDRESS_PROCESSING_DONE: 'ADDRESS_PROCESSING_DONE',

    SET_LOCATION_CONFIRMED: 'SET_LOCATION_CONFIRMED',
    SET_IS_ADDRESS_DELIVERABLE: 'SET_IS_ADDRESS_DELIVERABLE',

    SET_COUNTRY_CODE_FROM_IP: 'SET_COUNTRY_CODE_FROM_IP',
    SET_COUNTRY_FOR_GLOBAL_ASSORTMENT: 'SET_COUNTRY_FOR_GLOBAL_ASSORTMENT',

    SET_CHOICE_BUTTON: 'SET_CHOICE_BUTTON',
    SET_ENTERED_ADDRESS: 'SET_ENTERED_ADDRESS',
    RESET_ENTERED_ADDRESS: 'RESET_ENTERED_ADDRESS',

    SET_CLEAR_CART: 'SET_CLEAR_CART',
}

export const displayAlcoholRestriction = payload => ({
    type: actions.DISPLAY_ALCOHOL_RESTRICTION_MODAL,
    payload,
})

export const setAddressProcessing = () => ({
    type: actions.ADDRESS_PROCESSING_DONE,
})

export const setAddress = address => ({
    type: actions.SET_ADDRESS,
    payload: address,
})
export const setIsAddressDeliverable = status => ({
    type: actions.SET_IS_ADDRESS_DELIVERABLE,
    payload: status,
})

export const setTempAddress = address => ({
    type: actions.SET_TEMP_ADDRESS,
    payload: address,
})

export const setTempStoreDetails = storeDetails => ({
    type: actions.SET_TEMP_STORE_DETAILS,
    payload: storeDetails,
})

export const transferTempToSelected = () => ({
    type: actions.TRANSFER_TEMP_TO_SELECTED,
})

export const transferAllTemp = () => ({
    type: actions.TRANSFER_ALL_TEMP,
})

export const setStoreDetails = storeDetails => ({
    type: actions.SET_STORE_DETAILS,
    payload: storeDetails,
})

export const setSavedAddresses = addresses => ({
    type: actions.SET_SAVED_ADDRESSES,
    payload: addresses,
})

export const setCountryForGlobalAssortment = country => ({
    type: actions.SET_COUNTRY_FOR_GLOBAL_ASSORTMENT,
    payload: country,
})

export const getPlaceDetails = (placeId, navigate) => ({
    type: actions.GET_PLACE_DETAILS,
    payload: placeId,
    navigate,
})

export const getPlaceDetails_succcess = address => ({
    type: actions.GET_PLACE_DETAILS_SUCCESS,
    payload: address,
})

export const getPlaceDetails_failed = () => ({
    type: actions.GET_PLACE_DETAILS_FAILED,
})

export const getCoordinateDetails = (coordinates, navigate) => ({
    type: actions.GET_ADDRESS_FROM_COORDINATES,
    payload: coordinates,
    navigate,
})

export const getCoordinateDetails_succcess = address => ({
    type: actions.GET_ADDRESS_FROM_COORDINATES_SUCCESS,
    payload: address,
})

export const getCoordinateDetails_failed = () => ({
    type: actions.GET_ADDRESS_FROM_COORDINATES_FAILED,
})

export const getAlcoholRestriction = address => ({
    type: actions.GET_ALCOHOL_RESTRICTIONS,
    payload: address,
})

export const setAlcoholRestriction = restrictions => ({
    type: actions.SET_ALCOHOL_RESTRICTIONS,
    payload: restrictions,
})

export const verifyPlace = address => ({
    type: actions.VALIDATE_USPS,
    payload: address,
})

export const verifyPlace_success = validation => ({
    type: actions.VALIDATE_USPS_SUCCESS,
    payload: validation,
})

export const verifyPlace_failed = () => ({
    type: actions.VALIDATE_USPS_FAILED,
})

export const getStoresByLocation = address => ({
    type: actions.GET_STORES_BY_LOCATION,
    payload: address,
})

export const getStoresByLocationSuccess = storesList => ({
    type: actions.GET_STORES_BY_LOCATION_SUCCESS,
    payload: storesList,
})

export const getStoresByLocationFailed = () => ({
    type: actions.GET_STORES_BY_LOCATION_FAILED,
})

export const updateAddressforpickup = address => ({
    type: actions.UPDATE_ADDRESS_FOR_PICKUP,
    payload: address,
})

export const setLocationConfirmed = flag => ({
    type: actions.SET_LOCATION_CONFIRMED,
    payload: flag,
})

export const getPickupStores = queryCountry => ({
    type: actions.GET_PICKUP_STORES,
    queryCountry,
})

export const pickupStoresSuccess = stores => ({
    type: actions.PICKUP_STORES_SUCCESS,
    payload: stores,
})

export const pickupStoresFailed = error => ({
    type: actions.PICKUP_STORES_FAILED,
    payload: error,
})

export const getStoreDetails = (store, countryChange) => ({
    type: actions.GET_STORE_DETAILS,
    payload: store,
    countryChange,
})

export const getStoreDetailsSuccess = details => ({
    type: actions.GET_STORE_DETAILS_SUCCESS,
    payload: details,
})

export const getStoreDetailsFailed = error => ({
    type: actions.GET_STORE_DETAILS_FAILED,
    payload: error,
})

export const filterStoresByState = payload => ({
    type: actions.FILTER_STORES_BY_STATE,
    payload,
})

export const filterStoreComplete = storesNearUser => ({
    type: actions.FILTER_STORES_COMPLETE,
    payload: storesNearUser,
})

export const resetStoreDetails = () => ({
    type: actions.RESET_STORE_DETAILS,
})

export const setChoiceButton = selectedButton => ({
    type: actions.SET_CHOICE_BUTTON,
    payload: selectedButton,
})

export const setEnteredAddress = enteredAddress => ({
    type: actions.SET_ENTERED_ADDRESS,
    payload: enteredAddress,
})

export const resetEnteredAddress = () => ({
    type: actions.RESET_ENTERED_ADDRESS,
})

export const setClearCartMessage = payload => ({
    type: actions.SET_CLEAR_CART,
    payload,
})
